import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import useApi from "../../../hooks/useApi";

const ModalNovoGrupo = ({ onGrupoCreated }) => {

    const { ambiente } = useAmbienteMedicao();
    const { closeModal } = useModal();
    const api = useApi();

    const [saving, setSaving] = useState(false);
    const [loadingNumber, setLoadingNumber] = useState(true);
    const [nextNumber, setNextNumber] = useState("");

    const [formValues, setFormValues] = useState({
        descricao: ""
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value.toUpperCase()
        }));

    }

    //Carrega grupos da obra para calcular o próximo number (último + 1) e exibir no formulário.
    useEffect(() => {

        const loadNextNumber = async () => {

            if (!ambiente?.id) return;

            try {

                setLoadingNumber(true);
                const { data } = await api.get("/Painel/API/ControleMedicao/ListGrupos/index.php?obra=" + ambiente.id);
                const maxNumber = Array.isArray(data) && data.length > 0
                    ? data.reduce((acc, g) => Math.max(acc, Number(g.number) || 0), 0)
                    : 0;
                setNextNumber(maxNumber + 1);

            } catch (e) {

                console.error(e);
                setNextNumber(1);

            } finally {

                setLoadingNumber(false);

            }

        }

        loadNextNumber();

    }, [ambiente]);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!ambiente?.id) {
            alert("Nenhum ambiente selecionado.");
            return;
        }

        if (!formValues.descricao.trim()) {
            alert("Informe a descrição do grupo.");
            return;
        }

        try {

            setSaving(true);

            const formData = new FormData();
            formData.append("obra", ambiente.id);
            formData.append("descricao", formValues.descricao);

            const { data } = await api.post("/Painel/API/ControleMedicao/CreateGrupo/", formData);
            console.log(data);

            closeModal();
            if (onGrupoCreated) {
                onGrupoCreated();
            }

        } catch (e) {

            console.error(e);

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal header close={closeModal}>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="OBRA"
                        type="text"
                        readOnly
                        valor={ambiente?.descricao || ""}
                    />
                    <FormComp
                        title="NÚMERO DO GRUPO"
                        type="text"
                        readOnly
                        valor={loadingNumber ? "CALCULANDO..." : String(nextNumber)}
                    />
                    <FormComp
                        title="DESCRIÇÃO DO GRUPO"
                        type="text"
                        name="descricao"
                        valor={formValues.descricao}
                        changeFunc={handleChange}
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={saving ? "SALVANDO..." : "SALVAR"}
                        disabled={saving || loadingNumber}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalNovoGrupo;
